import React from "react";
import { ManageCompanyClassificationContainer } from "../../containers";

const ManageCompanyClassification = (props) => {
  return <ManageCompanyClassificationContainer {...props} />;
};

export default ManageCompanyClassification;
